import {useEffect, useContext} from 'react'
import DB from '../../DAL/DB'
import {useDBSubscribe} from '../../effects'
import {auth} from '../../Auth'
import {ReducerContext} from '../reducer'

const rolling_average_scores = new DB.RollingAverageScores()

export default function useRollingAverages(activeTab) {
  const {dispatch, state} = useContext(ReducerContext)

  const agg_type = state.dropdown.aggregation || 'field_user'
  
  // Determine the selected user based on aggregation type
  const selectedUser = agg_type === 'reviewer' 
    ? state.dropdown.reviewer 
    : agg_type === 'installer'
      ? state.dropdown.installerUser
      : state.dropdown.fieldUser;
  
  const shouldSubscribe = state.dropdown.rubric && activeTab === '3' && agg_type

  console.log('useRollingAverages:', {
    shouldSubscribe,
    activeTab,
    rubric: state.dropdown.rubric,
    agg_type,
    selectedUser
  })

  // Build filters based on aggregation type and selected user
  let filters = [
    ['aggregated_by', '==', agg_type],
    [`${agg_type}_org_id`, '==', auth.sunkaizenUser.organization.id]
  ]

  if (state.dropdown.rubric) {
    filters.push(['rubric', '==', state.dropdown.rubric])
  }

  // Add user-specific filter if a specific user is selected
  if (selectedUser && selectedUser !== 'All' && selectedUser !== 'select') {
    filters.push([agg_type, '==', selectedUser])
  }

  console.log('Rolling averages filters:', filters)

  const ra = useDBSubscribe(
    rolling_average_scores,
    shouldSubscribe
      ? { filters }
      : { filters: [['aggregated_by', '==', 'none']] }
  )

  useEffect(
    function () {
      console.log('Rolling averages data received:', ra)
      dispatch({type: `projectAvgs`, value: ra})
    },
    [ra]
  )
}
